import { render, staticRenderFns } from "./RollCallInsideStudent.vue?vue&type=template&id=42464020&"
import script from "./RollCallInsideStudent.vue?vue&type=script&lang=js&"
export * from "./RollCallInsideStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports